
import React from 'react';
import { Link } from 'react-router-dom';

const DashboardSidebar = ({ active = "Total Earnings", setter = ()=>{} }) => {

  const menuItems = [

    {
      id: 0,
      title: "Total Earnings",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#64748B" className="bi bi-bar-chart-line-fill" viewBox="0 0 16 16">
          <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1z" />
        </svg>
      ),
      url: "/dashboard/total-earnings",
      isActive: false
    },
    {
      id: 1,
      title: "Subscriptions",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#64748B" className="bi bi-tags-fill" viewBox="0 0 16 16">
          <path d="M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
          <path d="M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043z" />
        </svg>
      ),
      url: "/dashboard/subscriptions/list",
      isActive: true
    },
    {
      id: 2,
      title: "User List",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#64748B" className="bi bi-people-fill" viewBox="0 0 16 16">
          <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
        </svg>
      ),
      url: "/dashboard/user/list",
      isActive: false
    },
    {
      id: 3,
      title: "Clone List",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#64748B" className="bi bi-person-vcard-fill" viewBox="0 0 16 16">
          <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm9 1.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5M9 8a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4A.5.5 0 0 0 9 8m1 2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5m-1 2C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 0 2 13h6.96q.04-.245.04-.5M7 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0" />
        </svg>
      ),
      url: "/dashboard/clone/list",
      isActive: false
    },
    {
      id: 4,
      title: "Order List",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#64748B" className="bi bi-cart-fill" viewBox="0 0 16 16">
          <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
        </svg>
      ),
      url: "/dashboard/orders/list",
      isActive: false
    },
  ]?.map(item => {
    if (item?.title === active) {
      return {
        ...item,
        isActive: true
      }
    } else {
      return {
        ...item,
        isActive: false
      }
    }
  });

  return (
    <div className="tyn-aside tyn-aside-base">
      

      <div className="tyn-aside-head">
        <div className="tyn-aside-head-text">
          <h3 className="tyn-aside-title tyn-title">Dashboard</h3>
        </div>
      </div>

      <div className="tyn-aside-body" data-simplebar>
        <ul className="tyn-aside-list">
          {menuItems?.map(item => (
            <li key={item.id} className={`tyn-aside-item tyn-aside-item-bubbly js-toggle-main my-1 ${item?.isActive ? 'active' : ''}`} onClick={()=>setter(true)}>
              <Link to={item.url} className="tyn-media-group"> 
                <div className="tyn-media tyn-size-sm">
                  {item?.icon}
                </div>
                <div className="tyn-media-col">
                  <div className="content">{item.title}</div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DashboardSidebar;
